import b from 'b_';
import { CalendarIntervalDay, Spin, Text } from 'platform-components';
import React, { useCallback } from 'react';
import { accessibleClick } from '@edu-frontend/modules/src/shared/lib/a11y';

import { block } from '../constants';

import './course-calendar__load-more.scss';

interface CourseCalendarLoadMoreProps {
    day: CalendarIntervalDay;
    hiddenCards: number;
    isLoading: boolean;
    allCards: number;
    onClick: (day: CalendarIntervalDay, maxVisibleCards: number) => void;
}

export const CourseCalendarLoadMore = ({
    day,
    allCards,
    onClick,
    isLoading,
    hiddenCards,
}: CourseCalendarLoadMoreProps) => {
    const handleShowMore = useCallback(() => {
        if (!isLoading) {
            onClick(day, allCards);
        }
    }, [onClick, allCards, day, isLoading]);

    return (
        <div className={b(block, 'load-more')} {...accessibleClick(handleShowMore)}>
            {!isLoading && (
                <Text id="lessons.calendar.showMore" values={{ number: hiddenCards }} weight={Text.WEIGHT.M} />
            )}
            {isLoading && <Spin size={Spin.SIZE.XS} />}
        </div>
    );
};
